export default "__VITE_ASSET__D4OvdV6p__"